export const OPPORTUNITY_DATA_TERMINATE_LOADING = 'OPPORTUNITY_DATA_TERMINATE_LOADING';
export const OPPORTUNIY_UPDATED = 'OPPORTUNITY_UPDATED';

export function opportunityDataTerminateLoading(opportunity) {
  return {
    type: OPPORTUNITY_DATA_TERMINATE_LOADING,
    opportunity,
  };
}

export function opportunityUpdated(opportunity) {
  return {
    type: OPPORTUNIY_UPDATED,
    opportunity,
  };
}



// WEBPACK FOOTER //
// ./src/services/SFOpportunityService/actions.js